import { Link } from "@components/ui-kit";
import { TIME_BILLING_URL_PARAMS } from "@src/components/modules/projects/time-billing/constants";

type TimeBillingLinkProps = {
  readonly projectId: string;
  readonly timeBillingId: string;
  readonly name?: string | null;
  readonly color?: string;
};

export const TimeBillingLink = ({
  projectId,
  timeBillingId,
  name,
  color,
}: TimeBillingLinkProps) => (
  <Link
    data-testid="time-billing-link"
    color={color}
    target="_blank"
    href={{
      pathname: "/projects/time-billing",
      query: {
        id: projectId,
        [TIME_BILLING_URL_PARAMS.EXPAND]: timeBillingId,
      },
    }}
  >
    {name ?? timeBillingId}
  </Link>
);
